(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/handlebars-helpers.js'); 
'use strict';

if (svs.isServer) {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

function registerHelpers(hbs) {
  hbs.registerHelper('getFirstLetter', function(name) {
    name = name || '';
    return name.charAt(0);
  });

  hbs.registerHelper('getWeekFromDate', function(date) {
    return svs.utils.date.WeekNr(date);
  });

  hbs.registerHelper('drawIsOpen', function(drawState, options) {
    return drawState.toLowerCase() === 'open'
      ? options.fn(this)
      : options.inverse(this);
  });

  hbs.registerHelper('drawIsFinalized', function(drawState, options) {
    return drawState.toLowerCase() === 'finalized'
      ? options.fn(this)
      : options.inverse(this);
  });

  hbs.registerHelper('getTeamStatus', function(team, options) {
    if (!team || !team.tipsSMDetails) {
      return false;
    }

    if (team.tipsSMDetails.currentDraw === 0) {
      team.tipsSMDetails.currentDraw = team.tipsSMDetails.firstDrawNumber;
    }

    var currentRoundNum =
      team.tipsSMDetails.currentDraw - team.tipsSMDetails.firstDrawNumber;
    currentRoundNum++;

    var status = {
      text: 'Inväntar spel för omgång ' + currentRoundNum,
      isReady: false,
      isComplete: false
    };
    var args = [];

    if (
      !team.complete &&
      svs.utils.ns.isNamespace('svs.competition.core.data.firstDraw') &&
      svs.competition.core.data.firstDraw.regCloseTime &&
      new Date(svs.competition.core.data.firstDraw.regCloseTime) < new Date()
    ) {
      status.text = 'Deltar ej';
    } else if (
      svs.competition.core.data.currentDraw &&
      svs.competition.core.data.currentDraw.drawNumber &&
      parseInt(svs.competition.core.data.currentDraw.drawNumber, 10) >
        team.tipsSMDetails.firstDrawNumber + team.tipsSMDetails.numDraws - 1
    ) {
      status.isComplete = true;
      status.text = '';
    } else if (
      team.numberOfInvitations &&
      team.tipsSMDetails.currentDraw === team.tipsSMDetails.firstDrawNumber
    ) {
      status.text = 'Inväntar svar från inbjudna';
    } else if (!team.complete) {
      status.text = 'För få medlemmar';
    } else if (team.allPlayedCurrentRound) {
      status.text = 'Alla spel för omgång ' + currentRoundNum + ' lagda';
      status.isReady = true;
    }

    args.push(status.text);
    args.push(status.isReady);
    args.push(status.isComplete);

    return options.fn(this, { data: options.data, blockParams: args });
  });
}

 })(window);